import { industriesResources } from "../Resources/Industries";
import { getLang } from "../lib";
import FadeInOnScroll from "./FadeInOnScroll";
import { dropdownIds } from "../Resources/SharedResources";


function Industries() {
    const lang = getLang();
    document.title = industriesResources[lang].Title;

    // List of industries in order
    const industryList = [
        {
            Id: dropdownIds.industries.pharma,
            Data: industriesResources[lang].Pharmaceuticals,
        },
        {
            Id: dropdownIds.industries.tech,
            Data: industriesResources[lang].Technology,
        },
        {
            Id: dropdownIds.industries.manufacturing,
            Data: industriesResources[lang].Manufacturing,
        },
        {
            Id: dropdownIds.industries.retail,
            Data: industriesResources[lang].Retail,
        },
        {
            Id: dropdownIds.industries.professional,
            Data: industriesResources[lang].Professional,
        },
        {
            Id: dropdownIds.industries.healthcare,
            Data: industriesResources[lang].Healthcare,
        },
    ];

    return (
        <div className="page industries-page">
            <section className="industries-intro">
                <FadeInOnScroll delay={0.2}>
                    <h1>{industriesResources[lang].Title}</h1>
                    <p>{industriesResources[lang].Intro}</p>
                </FadeInOnScroll>
            </section>

            {industryList.map((industry, idx) => (
                <div
                    key={industry.Id}
                    id={industry.Id}
                    className={`page-item ${idx % 2 !== 0 ? "reverse" : ""} mb-50`}
                >
                    <FadeInOnScroll delay={0.3}>
                        <section className="txt-holder child-item">
                            <h1>{industry.Data.Title}</h1>
                            <p>{industry.Data.Overview}</p>

                            <h3>{industriesResources[lang].Includes}</h3>
                            <ul>
                                {industry.Data.Services.map((item, i) => (
                                    <li key={i}>{item}</li>
                                ))}
                            </ul>

                            <h3>{industriesResources[lang].Outcomes}</h3>
                            <ul>
                                {industry.Data.Outcomes.map((item, i) => (
                                    <li key={i}>{item}</li>
                                ))}
                            </ul>
                        </section>
                    </FadeInOnScroll>

                    <FadeInOnScroll delay={0.4}>
                        <div className="img-holder child-item">
                            <img
                                src={`/images/industries/${industry.Id}.jpg`}
                                alt={industry.Data.Title}
                            />
                        </div>
                    </FadeInOnScroll>
                </div>
            ))}
        </div>
    );
}

export default Industries;
